import request from '@core/services/request';

export const customerPortalAPI = {
	getCustomerInformation: (id: any) => request.post(`/CustomerPortal/LoadData?customerId=${id}`),
	redirectToPortal: (id: any) => request.post(`/CustomerPortal/RedirectToCustomerPortal?customerId=${id}`),
	sendPortalLink: (req: any) => request.post(`/CustomerPortal/SendPortalLink`, req),
	createBusinessCustomerFromPortal: (createBusinessCustomerRequest: any) =>
		request.post(`/CustomerPortal/CreateBusinessCustomerFromPortal`, createBusinessCustomerRequest),
	getBusinessInformation: (id: any) => request.get(`/CustomerPortal/GetBusinessInformation?id=${id}`),
	addVehicle: (addVehicleRequest: any) => request.post(`/CustomerPortal/CreateNewVehicle`, addVehicleRequest),
	removeVehicle: (vehicleId: any) => request.post(`/CustomerPortal/RemoveVehicle?vehicleId=${vehicleId}`),
	getAllVehicles: (id: any) => request.get(`/CustomerPortal/GetAllVehicles?id=${id}`),
	changeEmailRequest: (req: any) => request.post(`/CustomerPortal/ChangeEmailByCodeVerification`, req),
	changePhoneRequest: (req: any) => request.post(`/CustomerPortal/ChangePhoneByCodeVerification`, req),
	verifyNewEmailRequest: (req: any) => request.post(`/CustomerPortal/VerifyEmailByCodeVerification`, req),
	verifyNewPhoneRequest: (req: any) => request.post(`/CustomerPortal/VerifyPhoneByCodeVerification`, req),
};
